import React from 'react'
import Grid from '../layout/grid'

export default props => (
    <Grid cols={props.cols}>
        <div className='form-group form-group-sm'>
            <label className='label-gt' htmlFor={props.name}>{props.label}</label>
            <input {...props.input} className='form-control'
                placeholder={props.placeholder}
                readOnly={props.readOnly}
                type={props.type}
                id={props.id}
                name={props.name}
                min={props.min}
                max={props.max}
                value={props.value}
                // defaultValue={props.defaultValue}
                onBlur={props.onBlur}
                onChange={props.onChange}
            />
            
        </div>
    </Grid>
)